import { useState } from 'react';
import { AiUsageDashboardPanel } from './AiUsageDashboardPanel';
import { AiUsageLimitsPanel } from './AiUsageLimitsPanel';

/** v0.3.x (AIトークン利用状況の可視化と利用上限管理): Settings > AI設定。
 *  既存プレースホルダ (App.tsx `<PlaceholderSettingsPage title="AI設定" ...>`) を置換する。
 *  設計: docs/design/v03-ai-token-quota.md §7.1 */
type SubTab = 'dashboard' | 'limits';

export function AiSettingsPage() {
  const [tab, setTab] = useState<SubTab>('dashboard');

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-h2">AI 設定</h2>
        <p className="text-sm text-text-sub mt-1">AI機能の利用状況の確認と、組織ツリー・個人単位の月次利用上限を設定します</p>
      </div>
      <div className="flex gap-1 border-b border-surface-line">
        {([
          { key: 'dashboard' as const, label: '使用状況' },
          { key: 'limits' as const, label: '利用上限' },
        ]).map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`px-3 py-2 text-sm whitespace-nowrap border-b-2 transition ${
              tab === t.key ? 'border-brand-red text-brand-red font-semibold' : 'border-transparent text-text-sub hover:text-text-main hover:border-surface-line'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'dashboard' ? <AiUsageDashboardPanel /> : <AiUsageLimitsPanel />}
    </div>
  );
}
